import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useGetTelehealthSessionInfoCallback } from '../../../hooks';
import { useVideoPlatformCallback } from '../../../hooks/useVideoPlatform';
import { useTrackEvent } from '../../../segment/segment';
import { EventTypeEnum } from '../../../segment/types';
import { trySafely } from '../../../utils';
import { normalizeVideoPlatform } from '../../../video-sdk';
import { admissionTrackingHistory } from './analytics/AdmissionTrackingHistory';

export function useTrackJoinSessionError() {
  const { patientShortId, providerShortId } = useParams<{
    patientShortId: string;
    providerShortId: string;
  }>();
  const [getTelehealthSessionInfo] = useGetTelehealthSessionInfoCallback();
  const getVideoPlatform = useVideoPlatformCallback();
  const { userViewed } = useTrackEvent();

  return useCallback(
    async (error: unknown) => {
      const resolvedPatientShortId = patientShortId ?? '';
      const resolvedProviderShortId = providerShortId ?? '';
      const { data } =
        (await trySafely(
          getTelehealthSessionInfo({
            variables: { patientShortId, providerShortId },
          }),
        )) ?? {};
      userViewed(EventTypeEnum.JOIN_SESSION_ERROR, {
        patientShortId: resolvedPatientShortId,
        providerShortId: resolvedProviderShortId,
        appointmentShortId: data?.telehealthSessionInfo?.appointment?.shortId ?? '',
        source: normalizeVideoPlatform(getVideoPlatform()),
        txId: admissionTrackingHistory.getTransactionId() ?? '',
        errorCode: String(error),
      });
    },
    [getTelehealthSessionInfo, getVideoPlatform, patientShortId, providerShortId, userViewed],
  );
}
